import React, { useState, useRef, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../assets/css/dateRangePicker.css";
import {
  subDays,
  startOfMonth,
  endOfMonth,
  subMonths,
  startOfQuarter,
  endOfQuarter,
  subQuarters,
  format
} from "date-fns";

const DateRangeFilter = ({ 
  startDate,
   endDate, 
   onChange  = () => {}}) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Preset Logic
  const presets = [
    { label: "Today", range: [new Date(), new Date()] },
    { label: "Yesterday", range: [subDays(new Date(), 1), subDays(new Date(), 1)] },
    { label: "Last 7 Days", range: [subDays(new Date(), 6), new Date()] },
    { label: "Last Month", range: [startOfMonth(subMonths(new Date(), 1)), endOfMonth(subMonths(new Date(), 1))] },
    { label: "Last Quarter", range: [startOfQuarter(subQuarters(new Date(), 1)), endOfQuarter(subQuarters(new Date(), 1))] },
  ];

  const handlePresetClick = (range) => {
    onChange(range[0], range[1]);
    setIsOpen(false);
  };

  const handleCalendarChange = (dates) => {
    const [start, end] = dates;
    onChange(start, end);
  };

  const handleReset = () => {
    onChange(null, null);
    setIsOpen(false);
  };

  // Format Date to show Full Year (yyyy)
  const getButtonText = () => {
    if (startDate && endDate) {
      return `${format(new Date(startDate), "dd MMM yyyy")} – ${format(new Date(endDate), "dd MMM yyyy")}`;
    } else if (startDate) {
      return `${format(new Date(startDate), "dd MMM yyyy")} – ...`;
    }
    return "Select Date Range";
  };

  return (
    <div className="custom-date-picker-container" ref={containerRef}>
      {/* Trigger Button */}
      <button
        type="button"
        className={`date-picker-trigger ${isOpen ? 'active' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="trigger-content">
            <i className="bi bi-calendar3"></i>
            <span>{getButtonText()}</span>
        </div>
        <i className={`bi bi-chevron-${isOpen ? 'up' : 'down'} arrow-icon`}></i>
      </button>

      {/* Dropdown Body */}
      {isOpen && (
        <div className="date-picker-dropdown">
          {/* Sidebar */}
          <div className="date-picker-sidebar">
            <div className="preset-list">
              {presets.map((preset, index) => (
                <button
                  key={index}
                  className="preset-btn"
                  onClick={() => handlePresetClick(preset.range)}
                >
                  {preset.label}
                </button>
              ))}
            </div>
            {/* Reset Button */}
            <button className="reset-btn" onClick={handleReset}>
              Reset
            </button>
          </div>

          {/* Calendar */}
          <div className="date-picker-calendar-wrapper">
            <DatePicker
              selected={startDate ? new Date(startDate) : null}
              startDate={startDate ? new Date(startDate) : null}
              endDate={endDate ? new Date(endDate) : null}
              onChange={handleCalendarChange}
              selectsRange
              inline
              monthsShown={1}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default DateRangeFilter;
